"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = delegate;
function delegate(that, what, whom) {
  that[what] = whom[what].bind(whom);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZGVsZWdhdGUuanMiXSwibmFtZXMiOlsiZGVsZWdhdGUiLCJ0aGF0Iiwid2hhdCIsIndob20iLCJiaW5kIl0sIm1hcHBpbmdzIjoiOzs7OztrQkFBd0JBLFE7QUFBVCxTQUFTQSxRQUFULENBQWtCQyxJQUFsQixFQUF3QkMsSUFBeEIsRUFBOEJDLElBQTlCLEVBQW9DO0FBQ2pERixPQUFLQyxJQUFMLElBQWFDLEtBQUtELElBQUwsRUFBV0UsSUFBWCxDQUFnQkQsSUFBaEIsQ0FBYjtBQUNEIiwiZmlsZSI6ImRlbGVnYXRlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZGVsZWdhdGUodGhhdCwgd2hhdCwgd2hvbSkge1xuICB0aGF0W3doYXRdID0gd2hvbVt3aGF0XS5iaW5kKHdob20pO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/luggage/lib/lib/delegate.js
// module id = 135
// module chunks = 0